import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, DatePicker, Popconfirm, Card, Input, Select, Checkbox, Switch, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import axios from 'axios';
import dayjs from 'dayjs';
import AdminModal from "./AdminModal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;

const EnvironmentSortModal = (props) => {
    useEffect(() => {
        setItemList(props.data)
    }, [props.data,,props.open])

    const [itemList, setItemList] = useState([]);

    const handleDrop = (droppedItem) => {
        console.log({ droppedItem })
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...itemList];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        // Update State
        let add_blog_index = updatedList.map((value, index) => {
            return {
                ...value,
                blog_index: index
            }
        })

        setItemList(add_blog_index);
    };

    const handleEdit = () => {
        console.log({ itemList })
        axios
            .patch(`/cramSchool/api/blog/surrounding`, [...itemList])
            .then((response) => {
                if (response.data.status == 'success') {
                    props.setOpen(false);
                    message.success("修改成功")
                    props.get_data();
                } else {
                    props.setOpen(false);
                    message.error("修改失敗")
                    props.get_data();
                }
            })
    }
    
    return (
        <>

            <AdminModal
                {...props}
                handleEdit={handleEdit}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
                </>)}
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col>
                        <DragDropContext onDragEnd={handleDrop}>
                            <Droppable droppableId="list-container">
                                {(provided) => (
                                    <div
                                        className="list-container"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        <Row gutter={[24, 8]} align={'middle'}>
                                            {itemList.map((item, index) => (
                                                <>
                                                    <Col span={24}>
                                                        <Draggable
                                                            key={`${item.blog_id}`}
                                                            draggableId={`${item.blog_id}`}
                                                            index={index}>
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.dragHandleProps}
                                                                    {...provided.draggableProps}
                                                                >
                                                                    <div style={{ fontSize: '1.5em', borderStyle: 'outset', borderRadius: '5px', paddingLeft: '10px' }}>{item.title}</div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    </Col>
                                                </>
                                            ))}
                                        </Row>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Col>
                </Row>
            </AdminModal>
        </>
    )
}
export default EnvironmentSortModal;